const FETCH_DICTIONARY_WORDS = {
  START: 'START_FETCH_DICTIONARY_WORDS',
  COMPLETE: 'COMPLETE_FETCH_DICTIONARY_WORDS',
  FAIL: 'FAIL_FETCH_DICTIONARY_WORDS',
  CLEANUP: 'CLEANUP_FETCH_DICTIONARY_WORDS',
}

export default FETCH_DICTIONARY_WORDS
